/* eslint-disable @typescript-eslint/no-unused-vars */
export const experimentSettingsStyle = ({ palette = {} }) => ({
  '.grey-out': {
    position: 'relative',
    color: '#999 !important',
    '& a': {
      color: '#999 !important',
    },
    '& input': {
      color: '#999 !important',
    },
    '&::before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      width: '100%',
      height: '100%',
      zIndex: '1000',
    },
  },
  '.experiment-budget-alert': {
    '& .alert-info.form-group': {
      lineHeight: 1.5,
      margin: '8px 0',
      padding: 8,

      '& .alert-image': {
        marginTop: 3,
        float: 'left',
      },
    },
  },
});
